export default {
  Other: 'attachments.Other',
  VendorManual: 'attachments.VendorManual',
  PO: 'attachments.PO'
}
